<template>
  <div class="tw-overflow-x-auto">
    <table class="bk-table bk-table--compact">
      <thead>
        <tr>
          <th>Source name</th>
          <th>Process</th>
          <th>Next run</th>
          <th>Cron schedule</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="cronSchedule of orderedCronSchedules()"
          :key="cronSchedule.sourceName + ':' + cronSchedule.type"
          :class="{ 'tw-opacity-50': !cronSchedule.enabled }"
        >
          <td class="tw-font-semibold">{{ cronSchedule.sourceName }}</td>
          <td><Tag :value="cronSchedule.type" /></td>
          <td><DisplayDatetimeCron :cron-schedule="cronSchedule" /></td>
          <td><CronStrings :cron-strings="cronSchedule.cronStrings" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CronStrings from './CronStrings'
import DisplayDatetimeCron from './DisplayDatetimeCron'
import orderBy from 'lodash/orderBy'
import { getNextDateFromCronStrings, getNextTimeoutFromCronStrings } from '../../lib/sync/utils/datetime'

export default {
  props: {
    cronSchedules: Array,
  },
  data() {
    return { timeoutIds: new Set() }
  },
  methods: {
    orderedCronSchedules() {
      const a = []
      for (const schedule of this.cronSchedules) {
        for (const type of ['sync', 'purge', 'reconcile']) {
          if (schedule[type]) {
            a.push({
              sourceName: schedule.sourceName,
              type,
              nextDate: schedule[type].nextDate,
              cronStrings: schedule[type].cronStrings,
              enabled: schedule[type].enabled,
            })
          }
        }
      }
      return orderBy(a, x => getNextDateFromCronStrings(x.cronStrings), ['asc'])
    },
    setTimeoutsForDisplay() {
      for (const cronSchedule of this.orderedCronSchedules()) {
        this.setTimeoutForDisplay(cronSchedule)
      }
    },
    setTimeoutForDisplay(cronSchedule) {
      const milliseconds = getNextTimeoutFromCronStrings(cronSchedule.cronStrings)
      const timeoutId = setTimeout(() => {
        this.timeoutIds.delete(timeoutId)
        this.setTimeoutForDisplay(cronSchedule)
      }, milliseconds)
      this.timeoutIds.add(timeoutId)
    },
  },
  mounted() {
    this.setTimeoutsForDisplay()
  },
  beforeDestroy() {
    for (const timeoutId of this.timeoutIds) {
      clearTimeout(timeoutId)
    }
  },
  components: {
    CronStrings,
    DisplayDatetimeCron,
  },
}
</script>
